// extracted by mini-css-extract-plugin
export var backdrop = "index-module--backdrop--0dzK-";
export var container = "index-module--container--EmSMq";
export var designation = "index-module--designation--9wn1W";
export var joinUsButton = "index-module--joinUsButton--zEkSd";
export var label = "index-module--label--BR4RV";
export var name = "index-module--name--KIefZ";
export var priceText = "index-module--priceText--+R8Mi";
export var product = "index-module--product--rdA97";
export var productContent = "index-module--productContent--HKzmG";
export var productShot = "index-module--productShot--qqhCu";
export var productTitle = "index-module--productTitle--GZQIE";
export var products = "index-module--products--C25p9";
export var profile = "index-module--profile--tA3HN";
export var profiles = "index-module--profiles--GNdOh";
export var title = "index-module--title--bgg46";